import { render } from "./cell_stop_tag.vue?vue&type=template&id=65c19512"
import script from "./cell_stop_tag.vue?vue&type=script&lang=ts"
export * from "./cell_stop_tag.vue?vue&type=script&lang=ts"

import "./cell_stop_tag.vue?vue&type=style&index=0&id=65c19512&lang=less"
script.render = render

export default script